import { LDSIcon, LDSHeading } from "@resmed/lumina-design-system";
import Icons from "@resmed/lumina-design-system-assets/dist/icons";

export interface MessageContentProps {
  content: string;
  isDeleted?: boolean;
  hasAttachment?: boolean;
}

/** Renders the correct message body based on deleted/attachment/normal state — mirrors mobile MessageContent. */
const MessageContent = ({ content, isDeleted, hasAttachment }: MessageContentProps) => {
  if (isDeleted) {
    return (
      <span className="lds-flex lds-items-center lds-gap-2">
        <LDSIcon icon={Icons.FaTrashCan} width="16" height="16" className="lds-opacity-50 lds-shrink-0" />
        <LDSHeading size="h5" className="lds-font-normal lds-italic lds-text-xs lds-text-textcolor-caption">
          This message has been deleted.
        </LDSHeading>
      </span>
    );
  }

  if (hasAttachment) {
    return (
      <span className="lds-flex lds-items-center lds-gap-2">
        <LDSIcon icon={Icons.FaPaperclip} width="16" height="16" className="lds-opacity-50 lds-shrink-0" />
        <LDSHeading size="h5" className="lds-font-normal lds-italic lds-text-xs lds-text-textcolor-caption">
          Attachments cannot be viewed in Engage. Please view from desktop.
        </LDSHeading>
      </span>
    );
  }

  return (
    <span className="lds-block lds-font-sans lds-text-base lds-font-normal lds-leading-6 lds-tracking-normal lds-text-textcolor-default">
      {content}
    </span>
  );
};

export default MessageContent;
